import { useCallback, useState } from 'react'

export type DeckDirection = 1 | -1

export function useProjectDeck(count: number) {
  const [index, setIndex] = useState(0)
  const [direction, setDirection] = useState<DeckDirection>(1)
  const [isFlipped, setIsFlipped] = useState(false)

  const move = useCallback(
    (dir: DeckDirection) => {
      setDirection(dir)
      setIsFlipped(false)
      setIndex((current) => (current + dir + count) % count)
    },
    [count],
  )

  const goTo = useCallback(
    (target: number) => {
      if (target === index) return
      setDirection(target > index ? 1 : -1)
      setIsFlipped(false)
      setIndex(target)
    },
    [index],
  )

  const next = useCallback(() => move(1), [move])
  const previous = useCallback(() => move(-1), [move])
  const toggleFlip = useCallback(() => setIsFlipped((flipped) => !flipped), [])

  return { index, direction, isFlipped, next, previous, goTo, toggleFlip }
}
